import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import CaptainModal from '../../../Components/CaptainModal';
import { IAssesment } from '../helpers/typings';

type AssessmentDataJsonModalProps = {
    isOpen: boolean;
    onClose: () => void;
    data: IAssesment;
    onSave: (data: IAssesment) => void;
};

const AssessmentDataJsonModal: React.FC<AssessmentDataJsonModalProps> = ({
    isOpen,
    onClose,
    data,
    onSave,
}) => {
    const [jsonText, setJsonText] = useState('');
    const [jsonError, setJsonError] = useState('');
    const wasOpen = useRef(false);

    useEffect(() => {
        if (isOpen && !wasOpen.current) {
            setJsonText(JSON.stringify(data, null, 2));
            setJsonError('');
        }
        wasOpen.current = isOpen;
    }, [isOpen, data]);

    const handleSave = () => {
        try {
            const parsed = JSON.parse(jsonText);
            if (
                typeof parsed !== 'object' ||
                parsed === null ||
                Array.isArray(parsed)
            ) {
                setJsonError('Assessment data must be a JSON object.');
                return;
            }
            setJsonError('');
            onSave(parsed as IAssesment);
            onClose();
        } catch {
            setJsonError('Invalid JSON. Please fix the syntax and try again.');
        }
    };

    return (
        <CaptainModal isOpen={isOpen} onClose={onClose}>
            <div className="text-center fw-bold fs-4 mb-3">Edit Assessment Data (JSON)</div>
            <Form
                className="mb-3 mx-3"
                onSubmit={e => {
                    e.preventDefault();
                    handleSave();
                }}
            >
                <Form.Control
                    as="textarea"
                    rows={18}
                    className="font-monospace"
                    style={{ fontSize: '0.85rem' }}
                    value={jsonText}
                    onChange={e => {
                        setJsonText(e.target.value);
                        if (jsonError) {
                            setJsonError('');
                        }
                    }}
                    spellCheck={false}
                />
                {jsonError && (
                    <div className="text-danger small mt-2">{jsonError}</div>
                )}
                <div className="d-flex gap-2 mt-3">
                    <Button variant="secondary" className="w-50" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit" className="w-50">
                        Apply JSON
                    </Button>
                </div>
            </Form>
        </CaptainModal>
    );
};

export default AssessmentDataJsonModal;
